import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { titlevalidation } from "../../../Common/commonvalidation";

export default function ModalCity({
  cityname,
  setModalcity,
  hitApi,
  handleCityInputTitle,
}) {
  const initialValues = {
    city_name: cityname || "",
  };

  const validationSchema = Yup.object().shape({
    city_name: titlevalidation,
  });

  const handleSubmit = (values) => {
    setModalcity(false);
    hitApi();
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ setFieldValue }) => (
        <Form>
          <button
            onClick={() => setModalcity(false)}
            className ="btn close-button d-block"
          >
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
              alt=""
            />
          </button>
          <ModalBody>
            <h4>Edit City</h4>
            <div className ="form-group">
              <label>Enter City</label>
              <Field
                className ="form-control"
                type="text"
                name="city_name"
                placeholder="Your City"
                onChange={handleCityInputTitle}
              />
              <ErrorMessage
                name="city_name"
                component="div"
                className ="error"
              />
            </div>
          </ModalBody>
          <div className ="modal-footer ">
            <button className ="btn" type="submit">
              Save
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
}
